export let menuList = [
  {
    module: 'sale',
    name: 'Ventas',
    link: '/ventas',
    iconSVG: 'sale',
    subtitle: 'Genera venta, cotización y reporte de nota de venta',
    subMenuList: [
      {
        module: "customer",
        name: "Venta cliente",
        link: "/ventas/cliente",
        urlIcon: "sale/customer",
      },
      {
        module: 'enterprise',
        name: 'Cotización',
        link: '/ventas/empresa',
        urlIcon: 'sale/enterprise',
        notMobile: true
      },
      {
        module: "searchNote",
        name: "Búsqueda nota de venta",
        link: "/ventas/nota",
        urlIcon: "sale/searchNote",
      },
      {
        module: "dispatchesCanceled",
        name: "Despachos cancelados",
        link: "/ventas/despachos-cancelados",
        urlIcon: "sale/dispatchesCanceled",
      },
      {
        module: 'searchQuotation',
        name: 'Búsqueda de cotización',
        link: '/ventas/empresa/cotizacion',
        urlIcon: 'sale/searchQuotation'
        // notMobile: true
      },
      {
        module: 'productSearch',
        name: 'Búsqueda de producto',
        link: '/ventas/consulta-producto',
        urlIcon: 'sale/productSearch'
        // notMobile: true
      },
      {
        module: 'capabilitiesSimulator',
        name: 'Simulador de capacidades',
        link: '/ventas/simulador-capacidades',
        urlIcon: 'sale/simulator'
      }
    ]
  },
  {
    module: 'configuration',
    name: 'Configuración',
    link: '/configuracion',
    iconSVG: 'configuration',
    subtitle: 'Configura las diferentes opciones del sistema',
    subMenuList: [
      {
        module: "entity",
        name: "Entidades con capacidad",
        link: "/configuracion/entidades",
        urlIcon: "configuration/entity",
      },
      {
        module: "entity",
        name: "Entidades",
        link: "/configuracion/entidades",
        urlIcon: "configuration/entity",
      },
      {
        module: "dispatchZone",
        name: "Zonas de despacho",
        link: "/configuracion/zonas",
        urlIcon: "configuration/dispatchZone",
      },
      {
        module: "dispatchType",
        name: "Tipos de despacho",
        link: "/configuracion/tipos-de-despacho",
        urlIcon: "configuration/dispatchType",
      },
      {
        module: "shipping",
        name: "Fletes de despacho",
        link: "/configuracion/flete",
        urlIcon: "configuration/shipping",
      },
      {
        module: "entityRoute",
        name: "Rutas entre entidades",
        link: "/configuracion/rutas-entre-entidades",
        urlIcon: "configuration/entityRoute",
      },
      {
        module: "dispatchRoute",
        name: "Rutas de despacho",
        link: "/configuracion/rutas-de-despacho",
        urlIcon: "configuration/dispatchRoute",
      },
      {
        module: "securityStock",
        name: "Stock de seguridad",
        link: "/configuracion/stock-de-seguridad",
        urlIcon: "configuration/securityStock",
      },
      {
        module: "securityStockCes",
        name: "Stock de seguridad CES",
        link: "/configuracion/stock-de-seguridad-ces",
        urlIcon: "configuration/securityStock",
      },
      {
        module: "routeValidation",
        name: "Validación de rutas",
        link: "/configuracion/validacion-de-rutas",
        urlIcon: "configuration/routeValidation",
      },
      {
        module: "settings",
        name: "Ajustes",
        link: "/configuracion/ajustes",
        urlIcon: "configuration/settings",
      },
      {
        module: "settings-dispatch",
        name: "Ajustes de Despacho",
        link: "/configuracion/ajustes-despacho",
        urlIcon: "configuration/settings-dispatch",
      },
      {
        module: 'level-autorize',
        name: 'Niveles de autorización',
        link: '/configuracion/niveles-de-aprobacion',
        urlIcon: 'configuration/margin',
      },
      {
        module: 'pickingSetting',
        name: 'Configuración de picking',
        link: '/configuracion/configuracion-picking',
        urlIcon: 'configuration/pickingSetting'
      },
      {
        module: 'entityCapabilities',
        name: 'Capacidades por entidad',
        link: '/configuracion/capacidades-de-entidad',
        urlIcon: 'configuration/capacity-test'
      },
      {
        module: 'entityCapabilitiesHidden',
        name: 'Capacidad de picking',
        link: '/configuracion/capacidades-de-entidad/capacidad-picking',
        urlIcon: 'configuration/capacity-test'
      },
      {
        module: 'entityCapabilitiesHidden',
        name: 'Edición de capacidad de picking',
        link: '/configuracion/capacidades-de-entidad/capacidad-picking/:capacityNumber',
        urlIcon: 'configuration/capacity-test'
      },
      {
        module: 'entityCapabilitiesHidden',
        name: 'Capacidad de despacho',
        link: '/configuracion/capacidades-de-entidad/capacidad-despacho',
        urlIcon: 'configuration/capacity-test'
      },
      {
        module: 'entityCapabilitiesHidden',
        name: 'Edición de capacidad de despacho',
        link: '/configuracion/capacidades-de-entidad/capacidad-despacho/:capacityNumber',
        urlIcon: 'configuration/capacity-test'
      },
      {
        module: 'entityCapabilitiesHidden',
        name: 'Capacidad de retiro',
        link: '/configuracion/capacidades-de-entidad/capacidad-retiro',
        urlIcon: 'configuration/capacity-test'
      },
      {
        module: 'entityCapabilitiesHidden',
        name: 'Edición de capacidad de retiro',
        link: '/configuracion/capacidades-de-entidad/capacidad-retiro/:capacityNumber',
        urlIcon: 'configuration/capacity-test'
      },
      {
        module: "entityHidden",
        name: "Agrupación de entidades",
        link: "/configuracion/entidades/agrupacion",
        urlIcon: "configuration/entity",
      },
      {
        module: "entityHidden",
        name: "Edición de agrupación de entidades",
        link: "/configuracion/entidades/agrupacion/:id",
        urlIcon: "configuration/entity",
      },
      /*       {
              module: 'capabilitiesSimulator',
              name: 'Simulador de capacidades',
              link: '/configuracion/simulador-capacidades',
              urlIcon: 'sale/simulator'
            } */
      {
        module: 'deliveryWindowsSettings',
        name: 'Ventanas de entrega',
        link: '/configuracion/ventanas-de-despacho',
        urlIcon: 'configuration/time-settings'
      },
      {
        module: 'deliveryWindowsSettingsHidden',
        name: 'Edición de ventana de entrega',
        link: '/configuracion/ventanas-de-despacho/editar/:id',
        urlIcon: 'configuration/time-settings'
      },
            {
        module: 'deliveryWindowsSettingsHidden',
        name: 'Creación de ventana de entrega',
        link: '/configuracion/ventanas-de-despacho/crear',
        urlIcon: 'configuration/time-settings'
      },
      {
        module: 'calculationRange',
        name: 'Rango de cálculo',
        link: '/configuracion/rango-de-calculo',
        urlIcon: 'configuration/daysCalculation'
      },
      {
        module: 'calculationRangeHidden',
        name: 'Edición de rango de cálculo',
        link: '/configuracion/rango-de-calculo/editar/:id',
        urlIcon: 'configuration/daysCalculation'
      },
      {
        module: 'calculationRangeHidden',
        name: 'Creación de rango de cálculo',
        link: '/configuracion/rango-de-calculo/crear',
        urlIcon: 'configuration/daysCalculation'
      }
    ],
  },


  {
    module: 'operation',
    name: 'Operación',
    link: '/operacion',
    iconSVG: 'operations',
    subtitle: 'Administra el proceso de los pedidos',
    subMenuList: [
      {
        module: "dispatchManagement",
        name: "Administración de Despachos",
        link: "/operacion/administracion-despachos",
        urlIcon: "operation/dispatchManagement",
      },
      {
        module: "dispatchToCustomer",
        name: "Creación de viajes",
        link: "/operacion/despacho-a-clientes",
        urlIcon: "operation/dispatchToCustomer",
      },
      {
        module: "waybillPrint",
        name: "Impresión de Guías",
        link: "/operacion/impresion-de-guias",
        urlIcon: "operation/waybillPrint",
      },
      {
        module: "inStorePicking",
        name: "Retiro en tienda",
        link: "/operacion/retiro-en-tienda",
        urlIcon: "operation/inStorePicking",
      },
      {
        module: "inStorePickingLocation",
        name: "Ubicaciones de retiro en tienda",
        link: "/operacion/ubicaciones-de-retiro-en-tienda",
        urlIcon: "operation/inStorePickingLocation",
      },
      {
        module: "travels",
        name: "Viajes",
        link: "/operacion/viajes",
        urlIcon: "operation/travels",
      },
      {
        module: "returnManagement",
        name: "Gestión de Cambios y Devoluciones",
        link: "/operacion/gestion-de-intercambios",
        urlIcon: "operation/returnManagement",
      }
    ],
  },
  {
    module: 'report',
    name: 'Reportes',
    link: '/reportes',
    iconSVG: 'report',
    subtitle: 'Obtén el reporte de gestión',
    subMenuList: [
      {
        module: "reportPicking",
        name: "Reporte de picking",
        link: "/reportes/report-picking",
        urlIcon: "report/reportPicking",
      },
      {
        module: "storeReport",
        name: "Reporte de retiro en tienda",
        link: "/reportes/store-report",
        urlIcon: "report/storeReport",
      },
      {
        module: "dispatchReport",
        name: "Reporte de despachos",
        link: "/reportes/dispatch-report",
        urlIcon: "report/dispatchReport",
      },
      /* {
        module: "arrearReport",
        name: "Reporte de atrasos",
        link: "/reportes/arrear-report",
        urlIcon: "report/arrearReport",
      }, */
      {
        module: "saleNoteStatusReport",
        name: "Reporte de nota de venta",//"Reporte de estados de N/V",
        link: "/reportes/sale-note-status-report",
        urlIcon: "report/saleNoteStatusReport",
      },
      {
        module: "modificationReport",
        name: "Reporte de Consulta de Modificaciones",
        link: "/reportes/modification-report",
        urlIcon: "report/modificationReport",
      },
      {
        module: 'dispatchHistoryReport',
        name: 'Reporte de historial de despachos',
        link: '/reportes/dispatch-history-report',
        urlIcon: 'report/dispatchReportHistory'
      },
      {
        module: 'cancellationTicketReport',
        name: 'Reporte de tickets de anulación',
        link: '/reportes/cancellation-ticket-report',
        urlIcon: 'report/cancellationReport'
      },
      {
        module: "containerReport",
        name: "Reporte de contenedores",
        link: "/reportes/container-report",
        urlIcon: "report/reportContenedores",
      },
      {
        module: "discountsReport",
        name: "Reporte de descuentos",
        link: "/reportes/report-discount",
        urlIcon: "report/reportDiscounts",
      },
      {
        module: "settlementReport",
        name: "Reporte de formato de liquidaciones",
        link: "/reportes/settlement-report-format",
        urlIcon: "report/analytics",
      },
      {
        module: "auditReport",
        name: "Reporte de Auditoría",
        link: "/reportes/audit-report",
        urlIcon: "report/auditReport",
      },
      /*       {
              module: "cancellationsAndRefundsReport",
              name: "Proceso de cancelaciones y extornos",
              link: "/reportes/cancellations-and-refunds-report",
              urlIcon: "pick/audit/check-list",
            }, */
      {
        module: "capacityReport",
        name: "Reporte de capacidades",
        link: "/reportes/capacity-report",
        urlIcon: "report/capacity-report",
      },
      {
        module: "requiredSkusReport",
        name: "Reporte de SKUs Requeridos",
        link: "/reportes/required-skus-report",
        urlIcon: "report/requiredSkuReport",
      },
    ],
  },
  {
    module: 'picking',
    name: 'Picking',
    link: '/picking',
    iconSVG: 'picking_blue',
    subtitle: 'Gestiona picking tienda',
    subMenuList: [
      {
        module: "orderManagement",
        name: "Gestión de pedidos",
        link: "/picking/gestion-pedidos",
        urlIcon: "pick/orderManagement",
      },
      {
        module: "consolidatedPicking",
        name: "Gestión de despachos",
        link: "/picking/gestion-despachos",
        urlIcon: "pick/consolidatedPicking",
      },
      {
        module: "productividad",
        name: "Productividad picking",
        link: "/picking/productividad",
        urlIcon: "pick/productividad",
      },
      {
        module: 'ordersCancel',
        name: 'Pedidos cancelados',
        link: '/picking/pedidos-cancelados',
        urlIcon: 'pick/ordersCancel'
      },
      {
        module: 'reportOrders',
        name: 'Reporte de Pedidos',
        link: '/picking/report-pedidos',
        urlIcon: 'pick/orderReport'
      },
      {
        module: 'pickingAudit',
        name: 'Auditoría de Picking',
        link: '/picking/auditoria',
        urlIcon: 'pick/audit/check-list'
      },
      {
        module: 'lotsManagement',
        name: 'Gestión de lotes',
        link: '/picking/gestion-lotes',
        urlIcon: 'pick/lots-management/lots'
      },
      {
        module: 'lotsManagement',
        name: 'Creación de lotes',
        link: '/picking/gestion-lotes/crear-lote',
        urlIcon: 'pick/lots-management/new-lot',
        hidden: true
      }
    ]
  },


  /* =====================MODULO DASHBOARD =========================*/
  {
    module: 'dashboard',
    name: 'Dashboard DaD',
    link: '/dashboard',
    iconSVG: 'dashboard',
    subtitle: 'Indicadores de gestión',
    subMenuList: [
      {
        module: "dashboardPickingReportBI",
        name: "Reporte de Picking Tienda",
        link: "/dashboard/picking-report-bi",
        urlIcon: "dashboard/storePicking",
      },
      {
        module: "logisticSellerCenter",
        name: "Reporte Logística SellerCenter",
        link: "/dashboard/logistic-seller-center",
        urlIcon: "dashboard/sellerCenterLogistic",
      },
      {
        module: "agoraPayReport",
        name: "Reporte Pagos Agora",
        link: "/dashboard/agora-pay",
        urlIcon: "dashboard/agoraPay",
      },
      {
        module: "dashboardStoreWithdrawal",
        name: "Retiro en Tienda",
        link: "/dashboard/store-withdrawal",
        urlIcon: "dashboard/retiroEnTienda",
      },
      {
        module: "transportReport",
        name: "Reporte de Transportes",
        link: "/dashboard/transport-report",
        urlIcon: "dashboard/transportReport"
      },
      {
        module: "costSettlement",
        name: "Reporte Liquidación Costos",
        link: "/dashboard/cost-settlement",
        urlIcon: "dashboard/costSettlement"
      },
      {
        module: "operationsReport",
        name: "Reporte Operaciones Agora Shop",
        link: "/dashboard/operations-report",
        urlIcon: "dashboard/operationsReport"
      },
      {
        module: "devolutionSellerCenter",
        name: "Reporte Devoluciones SellerCenter",
        link: "/dashboard/devolution-seller-center",
        urlIcon: "dashboard/devolutionSellerCenter"
      },
      {
        module: "ontime",
        name: "Reporte On Time",
        link: "/dashboard/ontime-report",
        urlIcon: "dashboard/ontime",
      },
      {
        module: "tracingPicking",
        name: "Reporte Seguimiento Picking",
        link: "/dashboard/tracing-picking",
        urlIcon: "dashboard/tracingPicking",
      },
      {
        module: "consolidateDispatchReport",
        name: "Reporte Consolidado Despachos",
        link: "/dashboard/consolidated-dispatch-report",
        urlIcon: "dashboard/consolidateDispatchReport",
      },
      {
        module: "freightModification",
        name: "Reporte Modificación de Fletes",
        link: "/dashboard/freight-modification",
        urlIcon: "dashboard/freightModification",
      },
      {
        module: "dashboardStoreWithdrawalPending",
        name: "Reporte Pendientes de Retiro en Tienda",
        link: "/dashboard/store-withdrawal-pending",
        urlIcon: "dashboard/dashboardStoreWithdrawalPending",
      },
      {
        module: "controlTower",
        name: "Reporte Control Tower",
        link: "/dashboard/control-tower",
        urlIcon: "dashboard/controlTower",
      },
      {
        module: "todayPerformance",
        name: "Reporte Today's Performance",
        link: "/dashboard/today-performance",
        urlIcon: "dashboard/todayPerformance",
      },
      {
        module: "jokrStockControl",
        name: "Reporte Control Stock JOKR",
        link: "/dashboard/jokr-stock-control",
        urlIcon: "dashboard/jokrStockControl",
      },
      {
        module: "merkaoStockControl",
        name: "Reporte Control Stock MERKAO",
        link: "/dashboard/merkao-stock-control",
        urlIcon: "dashboard/merkaoStockControl",
      },
      {
        module: "historicalControlTower",
        name: "Reporte Control Tower Histórico",
        link: "/dashboard/historical-control-tower",
        urlIcon: "dashboard/historicalControlTower",
      },
      {
        module: "sellerIncidence",
        name: "Reporte Incidencias Seller",
        link: "/dashboard/seller-incidence",
        urlIcon: "dashboard/sellerIncidence",
      },
      {
        module: "externalPicking",
        name: "Reporte Picking Externo",
        link: "/dashboard/external-picking",
        urlIcon: "dashboard/externalPicking",
      },
      {
        module: "capacityReport",
        name: "Reporte Capacidades",
        link: "/dashboard/capacity-report-dashboard",
        urlIcon: "dashboard/capacityReport",
      },
      {
        module: "capacityReportLive",
        name: "Reporte Capacidades Live",
        link: "/dashboard/capacity-report-live",
        urlIcon: "dashboard/capacityReportLive",
      },
      {
        module: "jokrInventory",
        name: "Reporte Inventario JOKR",
        link: "/dashboard/jokr-inventory",
        urlIcon: "dashboard/jokrInventory",
      },
      {
        module: "lossJokrDashboard",
        name: "Reporte Merma JOKR",
        link: "/dashboard/loss-jokr-dashboard",
        urlIcon: "dashboard/lossJokrDashboard",
      },
      {
        module: "sellerCancellation",
        name: "Reporte Cancelaciones Seller",
        link: "/dashboard/seller-cancellation",
        urlIcon: "dashboard/sellerCancellation",
      },
      {
        module: "merkaoTripSettlement",
        name: "Reporte Liquidación Viajes Merkao",
        link: "/dashboard/merkao-trip-settlement",
        urlIcon: "dashboard/merkaoTripSettlement",
      },
      {
        module: "orderRegister",
        name: "Reporte Registro de Pedidos OE",
        link: "/dashboard/order-register",
        urlIcon: "dashboard/orderRegister",
      },
      {
        module: "discountReport",
        name: "Reporte Descuentos PRO",
        link: "/dashboard/discount-report",
        urlIcon: "dashboard/discountReport",
      },
      {
        module: "sellerCompliance",
        name: "Reporte Cumplimiento Seller",
        link: "/dashboard/seller-compliance",
        urlIcon: "dashboard/sellerCompliance",
      },
      {
        module: "leadtimeVtex",
        name: "Reporte Lead times VTEX",
        link: "/dashboard/leadtime-vtex",
        urlIcon: "dashboard/leadtimeVtex",
      },
      {
        module: "inkafarmaOrders",
        name: "Reporte Pedidos Inkafarma - Agora Shop",
        link: "/dashboard/inkafarma-orders",
        urlIcon: "dashboard/inkafarmaOrders",
      },
      {
        module: "stateOrder",
        name: "Reporte Estado de Pedidos",
        link: "/dashboard/state-order",
        urlIcon: "dashboard/stateOrder",
      },
      {
        module: "trxDad",
        name: "Reporte TRX DaD",
        link: "/dashboard/trx-dad",
        urlIcon: "dashboard/trxDad",
      },
      {
        module: "stateOrdersLive",
        name: "Reporte Estado de Pedidos - Live",
        link: "/dashboard/state-orders-live",
        urlIcon: "dashboard/stateOrdersLive",
      },
      {
        module: "sellerControlTower",
        name: "Reporte Control Tower Seller- Live",
        link: "/dashboard/seller-control-tower",
        urlIcon: "dashboard/sellerControlTower",
      },
    ]
  },

  {
    module: 'maintenance',
    name: 'Mantenimiento',
    link: '/mantenimiento',
    iconSVG: 'settings',
    subtitle: 'Mantenimiento de información DAD',
    subMenuList: [
      /*   {
          module: "location",
          name: "Ubicaciones de picking",
          link: "/mantenimiento/ubicaciones",
          urlIcon: "mantenimiento/pickingSetting",
        }, */
      {
        module: "carrier",
        name: "Transportistas",
        link: "/mantenimiento/transportista",
        urlIcon: "mantenimiento/carrier",
      },
      {
        module: 'customer',
        name: 'Clientes',
        link: '/mantenimiento/cliente',
        urlIcon: 'mantenimiento/customer',
      }
    ]
  },



  {
    module: "user-settings",
    name: "Usuario",
    link: "/soporte-de-usuario",
    iconSVG: "user-setting",
    subtitle: 'Soporte usuario'
  },
  /* =====================MODULO DE REPORTES EXTERNOS =========================*/
  {
    module: 'external',
    name: 'Reportes Externos',
    link: '/external',
    iconSVG: 'external-report',
    subtitle: 'Obten los reportes externos',
    subMenuList: [
      // {
      //   module: "dispatchReport",
      //   name: "Reporte de despachos",
      //   link: "/external/dispatch-report",
      //   urlIcon: "report/dispatchReport",
      // },
      {
        module: "storeReport",
        name: "Reporte de retiro en tienda",
        link: "/external/store-report",
        urlIcon: "report/storeReport",
      }
    ]
  },
  {
    module: 'soporte-de-usuario-externo',
    name: 'Usuarios Externos',
    link: '/soporte-de-usuario-externo',
    iconSVG: 'user-external',
    subtitle: 'Soporte usuarios externos',
    subMenuList: [
      {
        module: "user-external-settings",
        name: "Soporte de Usuarios Externos",
        link: "/soporte-de-usuario-externo/external-user",
        urlIcon: "usuario/user-settings",
      },
      {
        module: "user-external-settings",
        name: "Gestión de despachos terceros",
        link: "/soporte-de-usuario-externo/external-dispatch-management",
        urlIcon: "pick/consolidatedPicking",
      },
      {
        module: "stateOrdersLive",
        name: "Reporte Estado de Pedidos - Live",
        link: "/dashboard/state-orders-live",
        urlIcon: "dashboard/stateOrdersLive",
      },
      {
        module: "stateOrder",
        name: "Reporte Estado de Pedidos",
        link: "/dashboard/state-order",
        urlIcon: "dashboard/stateOrder",
      }
    ]
  },
  {
    module: "support",
    name: "Area de Soporte",
    link: "/support",
    iconSVG: "support-module",  
    subtitle: "Gestión de tickets de soporte",
    subMenuList: [
      {
        module: "ticket-status",
        name: "Estado de Tickets",
        link: "/support/ticket-status",
        urlIcon: "support/ticket-status",
      },
    ]
  },
];


export let days = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];

export const EMAIL = {
  PRO: "servicioalcliente@promart.pe",
  OE: "oechsle@oechsle.pe",
  SPSA: "noreply@plazavea.com.pe",
  RP: "servicioalcliente@realplazago.pe"
};

export const APLICATION_CODE = {
  PRO: "DAD-PROMART",
  OE: "DAD",
  SPSA: "DAD",
  RP: "DAD"
};

export const TEMPLATE_TYPE = {
  PRO: "HPSA_ONE_PROMART_GEN_OP",
  OE: "ORDER_PAYMENT_MAIL",
  SPSA: "PLAZAVEA_ORDER_PAYMENT_MAIL",
  RP: ""
};

export const TEMPLATE_TYPE_NOTIFICATION = {
  RETURN_RP: "RPLAZA_ORDER_RETURN",
  RETURN_SELLER_RP: "RPLAZA_ORDER_RETURN_SELLER",
  RETURN_OE: "TPSA_RETURNED_PRODUCT_SELLER_CENTER",
  RETURN_SELLER_OE: "TPSA_REQUEST_RECEIVED_SELLER_CENTER",
  RETURN_PRO: "HPSA_RETURNED_PRODUCT_SELLER_CENTER",
  RETURN_SELLER_PRO: "HPSA_REQUEST_RECEIVED_SELLER_CENTER",
  RETURN_SPSA: "PVEA_RETURNED_PRODUCT_SELLER_CENTER",
  RETURN_SELLER_SPSA: "PVEA_REQUEST_RECEIVED_SELLER_CENTER",
};

export const PLATFORM_TYPE = {
  PRO: "IRMA",
  OE: "IRMA",
  SPSA: "IRMA",
  RP: "IRMA"
};

export const MODULE_DEFAULT = [
  {
    active: true,
    moduleDescription: "Administración de cuenta",
    moduleId: 0,
    moduleIdentifier: "administrar-cuenta",
    moduleName: "administrar-cuenta"
  }
]

export const AUDIT_RESULT = [
  { state: 'CONFORME', id: 'agreed' },
  { state: 'OBSERVADO', id: 'observed' },
  { state: 'NO AUDITADO', id: 'notAudited' }
];

export const SEPARATED_BY_SPACE = ' ';

export const FIRST_ZERO_HOUR = '0';
export const MIDNIGHT_HOUR = '00:00';
export const ZERO_MINUTES = ':00';
export const DEFAULT_ERROR_MESSAGE = 'Error inesperado. Vuelva a intentarlo o contactar con soporte por favor.';

export let skusNotForSale = [
  {
    sku: '20199014',
    description: 'BELLS PANETON ZIPLOCK BL850GR',
    eanCode: '2200201990140'
  },
  {
    sku: '20251340',
    description: 'CANASTA PAPA NOEL ROJO',
    eanCode: '2200202513409'
  },
  {
    sku: '20251341',
    description: 'CANASTA REYES MAGOS AZUL',
    eanCode: '2200202513416'
  },
  {
    sku: '20251343',
    description: 'CANASTA NOCHE BUENA DORADO',
    eanCode: '2200202513430'
  }
];

export const SNACKBARMESSAGES = {
  recordsNotFound: "No se encontraron resultados para mostrar"
}
